export enum Role {
  Admin = 2,
  Vendor = 1,
  EndUser = 0
}
